import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@app-env';
import { LoggingService } from './logging.service';

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    private readonly runningEnvironmentVal: string;
    private readonly referrerVal: string = '';
    private readonly originVal: string = '';
    private readonly hostVal: string = '';

    constructor(@Inject(DOCUMENT) private readonly document: Document) {
        this.runningEnvironmentVal = this.getEnvironment();
        this.referrerVal = this.document.referrer;
        this.originVal = this.document.location.origin;
        this.hostVal = this.document.location.host;
    }

    public logEnvironmentVars() {
        LoggingService.log(window.location.hostname);
        LoggingService.log('Active Profile: ' + environment.profile);
        LoggingService.log('Running Environment: ' + this.runningEnvironment);
        LoggingService.log('Referrer: ' + this.referrerVal);
        LoggingService.log('Origin: ' + this.originVal);
        LoggingService.log('Host: ' + this.hostVal);
        LoggingService.log('REST URL: ');
    }

    get runningEnvironment(): string {
        return this.runningEnvironmentVal;
    }
    get referrer(): string {
        return this.referrerVal;
    }
    get origin(): string {
        return this.originVal;
    }
    get host(): string {
        return this.hostVal;
    }

    private getEnvironment(): string {
        // do anything environment specific here
        if (window.location.hostname.indexOf('local') !== -1) {
            return 'local';
        } else if (window.location.hostname.slice(0, 3) === 'dev') {
            return 'dev';
        } else if (window.location.hostname.slice(0, 2) === 'qa') {
            return 'qa';
        } else {
            return 'prod';
        }
    }
}
